import React, { useEffect, useState } from "react";
import API from '../Services/Auth'
import { ToastContainer, toast } from "react-toastify";
import { SERVER_URI } from "../Constant/server";
import axios from "axios";
import { responsivePropType } from "react-bootstrap/esm/createUtilityClasses";
import * as XLSX from "xlsx";

const Waiver = () => {
  const [waiver, setWaiver] = useState([])
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const perPage = 10;
  const [search, setSearch] = useState("")

  const [csvData, setCsvData] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);
  const today = new Date();
  const formattedToday = today.toISOString().split("T")[0];
  const pastDate = new Date();
  pastDate.setDate(pastDate.getDate() - 90);
  const formattedPastDate = pastDate.toISOString().split("T")[0];

  // const [getfile, setFile] = useState<File | null>(null);
  const [search1, setSearch1] = useState({
    searchText: "",
    from_date: formattedToday,
    to_date: formattedToday,
  });

  useEffect(() => {
    customerWaiverData(currentPage)
  }, [currentPage])

  // const handleFieldChange = (e, fieldName) => {
  //   const value = e.target.value;
  //   if (fieldName === "search") {
  //     setSearch(value);
  //     if (value.trim() === "") {
  //       setCurrentPage(1);
  //       customerWaiverData(1);
  //     }
  //   }
  // };

  const handleFieldChange = (e, fieldName) => {
    const value = e.target.value;

    if (fieldName === "search") {
      setSearch(value);

      if (value.trim() === "") {
        setCurrentPage(1);
        customerWaiverData(1);
      }
    } else {
      setSearch1((prev) => ({
        ...prev,
        [fieldName]: value,
      }));
    }
  };

  const customerWaiverData = async (currentPage) => {
    try {
      const payload = {
        limit: perPage,
        pageNumber: currentPage,
        search: search,
        start_date: search1.from_date || formattedToday,
        end_date: search1.to_date || formattedToday,  
      };
      const response = await API.getWaiverData(payload);
      setWaiver(response?.data?.data || []);
      const totalPages = Math.ceil(response?.data?.total_count / perPage);
      setTotalCount(response?.data?.total_count);
      setTotalPages(totalPages);
    } catch (error) {
      handleError(error);
      if (!error.response) {
        toast.error("Network error! Please check your internet connection");
      } else if (error.response.status === 403) {
        window.location.replace("/Login")
        // toast.error("Network error! Please check your internet connection.");
      } else {
        toast.error("An unexpected error occurred. Please try again.");
      }
    }
  };


  const handleError = (error) => {
    console.error("Error:", error);
    if (error.response) {
      toast.error(error.response.data?.message || `Error: ${error.response.status}`);
    } else if (error.request) {
      toast.error("No response from server. Please try again later.");
    } else {
      toast.error("Something went wrong. Please try again.");
    }
  };

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  const handleSearch = () => {
    if (search.trim() === "") {
      setCurrentPage(1);
      customerWaiverData(1);
    } else {
      setCurrentPage(1);
      customerWaiverData(1);
    }
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    setSelectedFile(file);

    const reader = new FileReader();
    reader.onload = ({ target }) => {
      const text = target.result;
      parseCSV(text);
    };

    reader.readAsText(file);
  };

  const parseCSV = (csvText) => {
    const rows = csvText.split("\n").map((row) => row.trim()).filter(row => row);
    if (rows.length === 0) {
      toast.error("CSV file is empty!");
      return;
    }

    const headers = rows[0].split(",");
    const data = rows.slice(1).map((row) => {
      const values = row.split(",");
      return headers.reduce((obj, header, index) => {
        obj[header.trim()] = values[index] ? values[index].trim() : "";
        return obj;
      }, {});
    });

    setCsvData(data);
  };

  const handleUpload = () => {
    if (!selectedFile) {
      toast.error("Please select a file to upload!");
      return;

    }
    try {
      const formData = new FormData();
      formData.append("xlsx", selectedFile);

      const authToken = localStorage.getItem("token");

      const headers = {
        Authorization: authToken ? `Bearer ${authToken}` : "",
      };
      axios
        .post(SERVER_URI + "/dashboard/update-bulk-waiver", formData, { headers })
        .then((response) => {
          toast.success(response.data.message);
          setTimeout(() => window.location.reload(), 2000);
        })
        .catch((error) => {
          console.error("Error uploading file:", error);
          toast.error("Error uploading file. Please try again.");
        });
    } catch (error) {
      console.error("Error during form submission:", error);
    }

  };

  const handleClose = () => {
    window.location.reload();
  }

  const getPageNumbers = () => {
    const maxVisible = 10;
    const pageNumbers = [];
    if (totalPages <= maxVisible) {
      for (let i = 1; i <= totalPages; i++) {
        pageNumbers.push(i);
      }
    } else {
      const left = Math.max(1, currentPage - 3);
      const right = Math.min(totalPages, currentPage + 3);

      if (left > 2) {
        pageNumbers.push(1, '...');
      } else {
        for (let i = 1; i < left; i++) {
          pageNumbers.push(i);
        }
      }
      for (let i = left; i <= right; i++) {
        pageNumbers.push(i);
      }
      if (right < totalPages - 1) {
        pageNumbers.push('...', totalPages);
      } else {
        for (let i = right + 1; i <= totalPages; i++) {
          pageNumbers.push(i);
        }
      }
    }
    return pageNumbers;
  };

  const handleView = async (id) => {
    try {
      const token = localStorage.getItem("token");
      const url = `${SERVER_URI}/get-waiver-detail/${id}`;

      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        responseType: 'blob',
      });

      const fileURL = URL.createObjectURL(response.data);
      const iframe = document.createElement('iframe');
      iframe.style.display = 'none';
      iframe.src = fileURL;

      document.body.appendChild(iframe);

      iframe.onload = function () {
        iframe.contentWindow.focus();
        iframe.contentWindow.print();
      };

    } catch (err) {
      console.error('Error fetching waiver details:', err);
      if (err?.response?.status === 403) {
        window.location.href = '/login';
      }
    }
  };
  const downloadCSV = async () => {
    //console.log('wwww');
    try {
      
      const payload = {
        start_date: search1.from_date || formattedToday,
        end_date: search1.to_date || formattedToday,
        //location_id: centerlist || null,
      };
      //console.log('rrrrrrrrrr',formattedToday || formattedPastDate);
      const response = await API.getWaiverDump(payload);
      const result = response?.data?.data || [];
      if (!result.length) {
        toast.error("No data found!");
        return;
      }
      const worksheet = XLSX.utils.json_to_sheet(result);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Waiver");
      XLSX.writeFile(workbook, "WaiverReport.xlsx");
    } catch (error) {
      console.error("Error downloading Excel:", error);
    }
  };

  return (
    <div>
      <div className="col-lg-12 grid-margin stretch-card">
        <div className="card">
          <div className="card-header d-flex justify-content-between align-items-center">
            <h4 className="card-title mb-0">Total Waiver  ({totalCount})</h4>

            {totalCount > 0 && (
              <button className="btn btn-primary btn-sm" onClick={downloadCSV}>
                <i className="fa fa-download"></i>
              </button>
            )}
            <button type="button" className="btn btn-primary" data-bs-toggle="modal" data-bs-target="#exampleModalwaver">
              Upload Bulk Waiver
            </button>
          </div>

          <div className="card-body">
            <div className="row mb-3">
              <div className="col-md-4">
                <label>Search By Name Or Mobile number</label>
                <input type="text" className="form-control" placeholder="Search By Name Or Mobile number"
                  value={search}
                  onChange={(e) => handleFieldChange(e, "search")}
                />
              </div>
              <div className="col-md-3">
                <label>From Date</label>
                <input
                  type="date"
                  className="form-control"
                  value={search1.from_date || ""}
                  // min={formattedPastDate}
                  max={formattedToday}
                  onChange={(e) => handleFieldChange(e, "from_date")}
                />
              </div>

              <div className="col-md-3">
                <label>To Date</label>
                <input
                  type="date"
                  className="form-control"
                  value={search1.to_date || ""}
                  min={search1.from_date}
                  max={
                    search1.from_date
                      ? new Date(
                        Math.min(
                          new Date(search1.from_date).setDate(new Date(search1.from_date).getDate() + 90),
                          new Date()
                        )
                      ).toISOString().split("T")[0]
                      : formattedToday
                  }
                  onChange={(e) => handleFieldChange(e, "to_date")}
                />
              </div>
              <div className="col-md-2">
                <label></label>
                <button onClick={handleSearch} className="btn btn-success" type="button">Search</button>
              </div>
            </div>
            <div className="table-responsive">
              <table className="table table-bordered text-center">
                <thead>
                  <tr>

                    <th>SrNo</th>
                    <th>Center Name</th>
                    <th>Customer Name</th>
                    <th>Phone</th>
                    <th>POC Name</th>
                    <th>Institute Name</th>
                    <th>Institute Address</th>
                    <th>Gender</th>
                    <th>Date of Birth</th>
                    <th>Is Active</th>
                    <th>Created Date</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {waiver.map((item, index) => (

                    <tr key={item.id}>
                      <td>{(currentPage - 1) * perPage + index + 1}</td>
                       <td>{item.center_name || "N/A"}</td>
                      <td>{item.customer_name || "N/A"}</td>
                      <td>{item.phone_number || "N/A"}</td>
                      <td>{item.poc_name || "N/A"}</td>
                      <td>{item.institute_name || "N/A"}</td>
                      <td>{item.institute_address || "N/A"}</td>
                      <td>{item.gender || "N/A"}</td>
                      <td>{item.date_of_birth || "N/A"}</td>
                      <td>{item.is_active ? "True" : "False"}</td>
                      <td>{item.createdAt || "N/A"}</td>
                      <td>
                        <button
                          className="btn btn-sm btn-primary"
                          onClick={() => handleView(item.id)}
                        >
                          Print
                        </button>
                      </td>

                    </tr>
                  ))}
                </tbody>
              </table>

              <nav aria-label="Page navigation example">
                <ul className="pagination justify-content-center mt-4">
                  <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                    <button
                      className="page-link"
                      onClick={() => handlePageChange(currentPage - 1)}
                      disabled={currentPage === 1}>
                      Previous
                    </button>
                  </li>
                  {/* {Array.from({ length: totalPages }, (_, index) => (
                    <li
                      key={index + 1}
                      className={`page-item ${currentPage === index + 1 ? "active" : ""}`}>
                      <button
                        className="page-link"
                        onClick={() => handlePageChange(index + 1)}>
                        {index + 1}
                      </button>
                    </li>
                  ))} */}
                  {getPageNumbers().map((page, index) => (
                    <li
                      key={index}
                      className={`page-item ${page === currentPage ? "active" : ""} ${page === "..." ? "disabled" : ""}`}
                    >
                      {page === "..." ? (
                        <span className="page-link">...</span>
                      ) : (
                        <button className="page-link" onClick={() => handlePageChange(page)}>
                          {page}
                        </button>
                      )}
                    </li>
                  ))}
                  <li
                    className={`page-item ${currentPage === totalPages ? "disabled" : ""}`} >
                    <button
                      className="page-link"
                      onClick={() => handlePageChange(currentPage + 1)}
                      disabled={currentPage === totalPages}>
                      Next
                    </button>
                  </li>
                </ul>
              </nav>
            </div>
          </div>


          <div className="modal fade" data-bs-backdrop="static" id="exampleModalwaver" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="exampleModalLabel">Upload CSV File</h5>
                  <button type="button" className="btn-close" data-bs-dismiss="modal" onClick={handleClose}></button>
                </div>

                <div className="modal-body">

                  <div className="row">
                    <div className="col-md-6">
                      <input type="file" className="form-control" accept=".csv" onChange={handleFileChange} />
                    </div>
                    <div className="col-md-4"></div>
                    <div className="col-md-2">
                      <a
                        href="https://files.ypaycard.com/SkyJumper/BULK_UPLOAD.csv"
                        download="demo.csv"
                        className="btn btn-link"
                      >
                        Demo File
                      </a>
                    </div>
                  </div>
                  {csvData.length > 0 && (
                    <div className="mt-3">
                      {/* <h6>CSV Preview:</h6> */}
                      <div className="table-responsive">
                        <table className="table table-bordered text-center">
                          <thead>
                            <tr>
                              {Object.keys(csvData[0]).map((header, index) => (
                                <th key={index}>{header}</th>
                              ))}
                            </tr>
                          </thead>
                          <tbody>
                            {csvData.map((row, rowIndex) => (
                              <tr key={rowIndex}>
                                {Object.values(row).map((value, colIndex) => (
                                  <td key={colIndex}>{value}</td>
                                ))}
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  )}
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-secondary" data-bs-dismiss="modal" onClick={handleClose}>Close</button>
                  <button type="button" className="btn btn-primary" onClick={handleUpload}>Upload</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ToastContainer />

    </div>

  );
};

export default Waiver;


// import React, { useState } from "react";
// import { ToastContainer, toast } from "react-toastify";

// const Waiver = () => {
//   const [csvData, setCsvData] = useState([]);
//   const [selectedFile, setSelectedFile] = useState(null);

//   const handleFileChange = (event) => {
//     const file = event.target.files[0];
//     if (!file) return;

//     setSelectedFile(file);

//     const reader = new FileReader();
//     reader.onload = ({ target }) => {
//       const text = target.result;
//       parseCSV(text);
//     };

//     reader.readAsText(file);
//   };

//   const parseCSV = (csvText) => {
//     const rows = csvText.split("\n").map((row) => row.trim()).filter(row => row);
//     if (rows.length === 0) {
//       toast.error("CSV file is empty!");
//       return;
//     }

//     const headers = rows[0].split(",");
//     const data = rows.slice(1).map((row) => {
//       const values = row.split(",");
//       return headers.reduce((obj, header, index) => {
//         obj[header.trim()] = values[index] ? values[index].trim() : "";
//         return obj;
//       }, {});
//     });

//     setCsvData(data);
//   };

//   const handleUpload = () => {
//     if (!selectedFile) {
//       toast.error("Please select a file to upload!");
//       return;
//     }
//     toast.success("File uploaded successfully!");
//     // Here you can send csvData to the server
//   };

//   return (
//     <div>
//        <button type="button"  className="btn btn-primary" data-bs-toggle="modal" data-bs-target="#exampleModalwaver">
//                Upload Bulk Waiver
//           </button>
//       <div className="modal fade" data-bs-backdrop="static" id="exampleModalwaver" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
//         <div className="modal-dialog modal-dialog-centered" role="document">
//           <div className="modal-content">
//             <div className="modal-header">
//               <h5 className="modal-title" id="exampleModalLabel">Upload CSV File</h5>
//               <button type="button" className="close" data-bs-dismiss="modal" aria-label="Close">
//                 <span aria-hidden="true">&times;</span>
//               </button>
//             </div>
//             <div className="modal-body">
//               <input type="file" className="form-control" accept=".csv" onChange={handleFileChange} />
//               {csvData.length > 0 && (
//                 <div className="mt-3">
//                   <h6>CSV Preview:</h6>
//                   <div className="table-responsive">
//                     <table className="table table-bordered text-center">
//                       <thead>
//                         <tr>
//                           {Object.keys(csvData[0]).map((header, index) => (
//                             <th key={index}>{header}</th>
//                           ))}
//                         </tr>
//                       </thead>
//                       <tbody>
//                         {csvData.map((row, rowIndex) => (
//                           <tr key={rowIndex}>
//                             {Object.values(row).map((value, colIndex) => (
//                               <td key={colIndex}>{value}</td>
//                             ))}
//                           </tr>
//                         ))}
//                       </tbody>
//                     </table>
//                   </div>
//                 </div>
//               )}
//             </div>
//             <div className="modal-footer">
//               <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
//               <button type="button" className="btn btn-primary" onClick={handleUpload}>Upload</button>
//             </div>
//           </div>
//         </div>
//       </div>
//       <ToastContainer />
//     </div>
//   );
// };

// export default Waiver;
